// import axios from 'axios';

// import { useAuth } from './useAuth';
// import { ADMIN_API_BASE_URL } from './Api';

// const useAxios = () => {
//     const { token } = useAuth();

//     const instance = axios.create({
//         baseURL: `${ADMIN_API_BASE_URL}`,
//     });

//     instance.interceptors.request.use((config) => {
//         if (token) {
//             config.headers.Authorization = `Bearer ${token}`;
//         }
//         return config;
//     });

//     return instance;
// };

// export default useAxios;

import axios from "axios";
import { ADMIN_API_BASE_URL } from '../Auth/Api';
// import { useAuth } from "./useAuth";

const token = localStorage.getItem("authToken");
console.log(token);

const authAxios = axios.create({
    baseURL: ADMIN_API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
        // Authorization: token ? `Bearer ${token}` : "",
        "Authorization": `Bearer ${token}`
    },
});

authAxios.interceptors.request.use(
    (config) => {
        const updatedToken = localStorage.getItem("authToken");
        if (updatedToken) {
            config.headers.Authorization = `Bearer ${updatedToken}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default authAxios;

// import axios from "axios";
// import { useAuth } from "./useAuth";
// import { ADMIN_API_BASE_URL } from "./Api";

// export const useApi = () => {
//   const { getToken, logout } = useAuth();
//   const token = localStorage.getItem("authToken");

//   const api = axios.create({
//     baseURL: ADMIN_API_BASE_URL,
//     headers: {
//       "Content-Type": "application/json",
//     },
//   });

//   // Add Authentication Token to Every Request
//   api.interceptors.request.use(
//     (config) => {
//     //   const token = getToken();
//       if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//       }
//       return config;
//     },
//     (error) => Promise.reject(error)
//   );

//   // Handle Unauthorized Access
//   api.interceptors.response.use(
//     (response) => response,
//     (error) => {
//       if (error.response && error.response.status === 401) {
//         console.log("⛔ Unauthorized! Redirecting to login.");
//         logout();
//       }
//       return Promise.reject(error);
//     }
//   );

//   return api;
// };
